export default {
  resume: {
    basic: true,
    techie: true,
    streak: true,
    businessmajor: true,
    simple: true,
    falcon: true,
    proxima: true,
    stellar: true,
    agricultural: true,
    functional: true,
    vintage: true,
    geospatial: true,
    classic: true,
  },
  'cover letter': {
    basic: true,
  },
};
